export const ellipsisEnd = (text: string, characters = 40, lines = 1) : string => {

    if (!text || text.length <= characters * lines) {
        return text;
    }

    const textArray = text.split(" ");
    const newTextArray = [];

    for(let line = 1; line <= lines; line++)
    {
        let lineLength = characters;
        while(lineLength > 0)
        {
            if(!textArray[0]?.length)
            {
                break;
            }
            if(textArray[0]?.length < lineLength)
            {
                lineLength -= textArray[0]?.length + 1;
                newTextArray.push(textArray.shift());
            }
            else if(line === lines && lineLength > 2 )
            {
                newTextArray.push(textArray.shift().substring(0,lineLength-2));
                break;
            }
            else
            {
                break;
            }
        }
    }
    return newTextArray.join(" ") + "…";
};
